import events from "./events.component";
import eventsUrls from "./events.urls";
import EventsTransforms from "./events.transforms";

const eventsModule = angular
  .module("app.components.events", [])
  .component("eventsPage", events)
  .service("EventsTransforms", EventsTransforms)
  .config(eventsUrls);

export default eventsModule;



// WEBPACK FOOTER //
// ./src/pages/events/events.module.js